import { FC } from 'react'
import { useArpMediaNotifications } from '../../../__legacy__/queries/arpMedia'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { ActivityNotification } from '../../notifications'
import { Recent } from '../primitives'
import { ArpRecentActivityEmptyState } from './ArpRecentActivityEmptyState'
import { RecentLoader } from './RecentLoader'

export const ArpRecentActivity: FC<{ media: IArpMedia }> = ({ media }) => {
  const { id, remixCount, favoriteCount, playCount } = media
  const { data, isLoading } = useArpMediaNotifications({ id, params: { perPage: 3 } })

  return (
    <Recent.Root>
      <Recent.Header>
        <Recent.Title>Recent Activity</Recent.Title>
        <Recent.Stats>{`${playCount} plays • ${remixCount} uses • ${favoriteCount} likes`}</Recent.Stats>
      </Recent.Header>
      {(() => {
        if (isLoading || !data) return <RecentLoader />
        const notifications = data.pages[0].data
        if (notifications.length === 0) return <ArpRecentActivityEmptyState media={media} />
        return data.pages[0].data.map((notification) => (
          <ActivityNotification key={notification.id} notification={notification} />
        ))
      })()}
    </Recent.Root>
  )
}
